import React, { useEffect, useRef } from "react";
import { Formik } from "formik";
import styles from "./UploadJourney.module.scss";
import { getInitialValues, validate } from "./initForm";

import ImageUploader from "../../Inputs/ImageUploader";
import UploadSelectionInput from "../../Inputs/UploadSelectionInput";
import UploadTextarea from "../../Inputs/UploadTextarea";
import SelectCityV3 from "../../Inputs/SelectCityV3";
import DateTextFieldsSpread from "../../Inputs/DateTextFieldsSpread";

const UploadJourney = ({
  onClose,
  onSubmit,
  uploadedImage,
  cities,
  setCities,
}) => {
  const locationRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    
    // Handle scroll when location input is focused
    const handleFocusIn = (e) => {
      if (locationRef.current && locationRef.current.contains(e.target)) {
        locationRef.current.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start',
          inline: 'nearest'
        });
      }
    };

    document.addEventListener('focusin', handleFocusIn);
    
    return () => {
      document.body.style.overflow = "unset";
      document.removeEventListener('focusin', handleFocusIn);
    };
  }, []);

  const initialValues = getInitialValues(uploadedImage);
  

  return (
    <div className={styles.UploadJourney}>
      <div className={styles.uploadForm}>
        <Formik
          initialValues={initialValues}
          validate={(values) => validate(values, cities)}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, values, touched, errors, isValid }) => {
            const isFormComplete =
              values.title &&
              values.photo &&
              values.description &&
              values.location &&
              values.date &&
              isValid;

            return (
              <form onSubmit={handleSubmit}>
                <div
                  className={`${styles.photo} ${
                    values.photo ? styles.filled : ""
                  }`}
                >
                  <UploadSelectionInput
                    name="title"
                    label="Title"
                    placeholder="Type here..."
                    isError={{
                      touched: touched.title,
                      text: errors.title,
                    }}
                  />
                  <div className={styles.imageUploaderStepOneRectangular}>
                    <ImageUploader
                      closeButton
                      name="photo"
                      label="Media"
                      placeholder="icon"
                      uploadPhoto
                      isRectangular={true}
                      isSquare={true}
                    />
                  </div>
                  <UploadTextarea
                    name="description"
                    label="Description"
                    placeholder="Type here..."
                  />
                  <div 
                    className={styles.selects}
                    ref={locationRef}
                  >
                    <SelectCityV3
                      name="location"
                      label="Location"
                      placeholder="*Type here..."
                      setCities={setCities}
                      options={cities}
                      isBlack={true}
                    />
                  </div>

                  <div className={styles.date}>
                    <DateTextFieldsSpread
                      name="date"
                      label="Date of memory"
                      placeholder="Type here..."
                    />
                  </div>
                </div>

                <div className={styles.delimiter} />
                <div className={styles.fields}></div>
                <div className={styles.delimiter} />
                <div className={styles.actions}>
                  <button
                  onClick={handleSubmit}
                    type="submit"
                    className={`${styles.addButton} ${
                      isFormComplete ? styles.complete : styles.incomplete
                    }`}
                  >
                    ADD
                  </button>

                  <button
                    type="button"
                    className={styles.cancelButton}
                    onClick={onClose}
                  >
                    CANCEL
                  </button>
                </div>
              </form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default UploadJourney;